import { QueryClient } from '@tanstack/react-query';

export function createQueryClient(overrides = {}) {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30 * 1000, retry: 1, refetchOnWindowFocus: false, ...overrides }
    }
  });
}

export const queryClient = createQueryClient();
